exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellBooleanType[data-v-63edf277] {\r\n  text-align: center;\n}\n.align-middle[data-v-63edf277] {\r\n  vertical-align: middle;\n}\r\n", ""]);

// exports
